(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["size-guide"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-size-guide-open]');
    if (opener) {
      var id = opener.getAttribute('data-size-guide-open');
      var modal = document.querySelector('[data-size-guide-modal="' + id + '"]');
      if (modal) {
        if (modal.parentElement !== document.body) {
          document.body.appendChild(modal);
        }
        modal.hidden = false;
        document.body.style.overflow = 'hidden';
      }
      return;
    }

    var closer = e.target.closest('[data-size-guide-close]');
    if (closer) {
      var id2 = closer.getAttribute('data-size-guide-close');
      var modal2 = document.querySelector('[data-size-guide-modal="' + id2 + '"]');
      if (modal2) {
        modal2.hidden = true;
        document.body.style.overflow = '';
      }
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      document.querySelectorAll('[data-size-guide-modal]').forEach(function (modal) {
        if (!modal.hidden) {
          modal.hidden = true;
          document.body.style.overflow = '';
        }
      });
    }
  });
  } catch(e) { console.error(e); }
})();

})();
